export const createSlotsLoading =  ({store})  => store.createSlotsReducer.loading;

export const createSlotsError =  ({store})  => store.createSlotsReducer.error;

export const createSlotsData =  ({store})  => store.createSlotsReducer.data;